const {AUTH_PATHS} = require('constants/path')

const authenticationRoutes = [
  {
    path: `/${AUTH_PATHS.SIGNUP}`,
    lazy: () => import('pages/unauthenticated/SignUp'),
    handle: {title: 'Sign up'},
  },
  {
    path: `/${AUTH_PATHS.EMAIL_VERIFY}`,
    lazy: () => import('pages/unauthenticated/Emailverify'),
    handle: {title: 'Email Verify'},
  },
  {
    path: `/${AUTH_PATHS.SIGNIN}`,
    lazy: () => import('pages/unauthenticated/SignIn'),
    handle: {title: 'Sign in'},
  },
  {
    path: `/${AUTH_PATHS.VERIFY_DOMAIN}`,
    lazy: () => import('pages/unauthenticated/DomainVerification'),
    handle: {title: 'Domain Verification'},
  },
  {
    path: `/${AUTH_PATHS.THANK_YOU}`,
    lazy: () => import('components/pages/ThankYou'),
    handle: {
      title: 'Thank You',
    },
  },
]

export default authenticationRoutes
